"use client";
import { v4 as uuidv4 } from "uuid";
import { LocalStorage } from "@/types/local-storage";

const generateUUID = (): void => {
	localStorage.setItem(LocalStorage.PosUUID, `pos-dashboard-${uuidv4()}`);
};

const getUUID = () => {
	if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
		return localStorage.getItem(LocalStorage.PosUUID);
	}
	return null;
};

const clearUUID = (): void => {
	if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
		localStorage.removeItem(LocalStorage.PosUUID);
	}
};

export { clearUUID, generateUUID, getUUID };
